import NavigationDropdown from '@/features/PortalNavigation/components/NavigationDropdown/NavigationDropdown';
import { PortalNavigationProps } from '@/features/PortalNavigation/PortalNavigation.interfaces';
import { InlineMenuItem } from '@/features/PortalNavigation/variants/inline/InlineMenuItem/InlineMenuItem';
import { useInlineNavigationStyles } from '@/features/PortalNavigation/variants/inline/InlineNavigation.styles';
import React, { Fragment, SyntheticEvent, useCallback, useMemo, useRef, useState } from 'react';

export const InlineNavigation = (props: PortalNavigationProps) => {
  const {
    navigationItems,
    'data-datalayer-position': datalayerPosition,
    'data-datalayer-variant': datalayerVariant,
  } = props;
  const classes = useInlineNavigationStyles();
  const menus = useMemo(() => navigationItems.filter((menu) => !menu.isDivider), [navigationItems]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [selectedRef, setSelectedRef] = useState<HTMLElement | null>(null);

  const onClick = useCallback(
    (event: SyntheticEvent, index: number) => {
      setSelectedIndex(menus[index].navigationItems?.length ? index : null);
      setSelectedRef(event.target as HTMLElement);
    },
    [menus],
  );

  const onCloseMenu = () => {
    setSelectedIndex(null);
    setSelectedRef(null);
  };

  return (
    <div
      className={classes.root}
      data-datalayer-position={datalayerPosition}
      data-datalayer-variant={datalayerVariant}
    >
      <div className={classes.menu}>
        {menus.map((menu, index) => (
          <Fragment key={index}>
            <InlineMenuItem
              menu={menu}
              onClick={(event: SyntheticEvent) => onClick(event, index)}
              isOpen={selectedIndex === index}
              hasSubMenu={!!menu.navigationItems?.length}
            />
            {selectedIndex === index && (
              <NavigationDropdown
                {...props}
                navigationItems={menu.navigationItems || []}
                onNavItemClick={onCloseMenu}
                onMenuClose={onCloseMenu}
                triggerButtonRef={selectedRef}
                horizontalAlignment="center"
                dropdownDistance={10}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
